import { injectable } from "tsyringe";
import { HelpCenterApiRepository } from "@/app/infrastructures/repositories/api/HelpCenterApiRepository";
import { HelpCenterVisitorToken } from "@/domain/entities/HelpCenterVisitorToken";

@injectable()
export class HelpCenterPresenter {
  private repository: HelpCenterApiRepository;

  constructor(repository: HelpCenterApiRepository) {
    this.repository = repository;
  }

  public getVisitorToken(): Promise<HelpCenterVisitorToken> {
    return this.repository.getVisitorToken();
  }
}
